import React, { Component } from 'react';
import Footer from '../components/footer'


import { VscCode,VscGlobe ,VscTriangleRight,VscFilePdf} from "react-icons/vsc";
import { AiFillDatabase,AiOutlineCloud,AiFillGithub } from "react-icons/ai";
import { MdPhoneAndroid } from "react-icons/md";
import { SiOracle,SiDocker } from "react-icons/si";
import ReactGA from "react-ga4";
ReactGA.initialize("G-K3LWES7Q5R");
ReactGA.send({ hitType: "Home", page: "/", title: "Home" });

class MainContent extends Component {

    render() {
        return<div className='mainContent'>
            <div id='about' className='about'>
            <div className='mb-3'>
                    <h2 className='abouttitile'>Zhyar A Jamal</h2>
                    <span className='aboutsubtitile'>Software Engeineer</span>
                    </div>
                <div className='row'>
                    <div className='col-lg-7 col-md-12'>

                    <div>
                    <span className='description'>Diligent software developer with +6 years' background in developing innovative software solutions to enhance business productivity , highly experienced in all aspects of the software developement lifecycle and end-to-end project management , Want to know more ? Check out my project portfolio and resume.</span>

                    </div>
                    <div className='mt-3 mb-4 ml-0'>
                    <button onClick={()=>window.location.href="#portfolio"}   style={{ "marginRight":"15px" }} className="btn btn-outline-dark" > <VscTriangleRight/> Portfolio</button>
                    <button onClick={()=>{
                        ReactGA.send({ hitType: "CV", page: "/resume", title: "CV" });
                        window.open("/resume.pdf","_blank")}} style={{ "marginRight":"15px" }} className="btn btn-outline-dark" ><VscFilePdf/> Resume</button>
                    </div>
                    </div>

                    <div className='col-lg-5 col-md-12'>
                        <p><b>Full Name :</b> Zhyar Abdalla Jamal</p>
                        <p><b>Nationality :</b> Iraqi, Kurdish</p>
                        <p><b>Education :</b> B.Sc. Degree in Software Engineering, Koya University, Koya, Iraq (2018-2019).</p>

                    </div>

                </div>

            </div>
            <div className='section'>
            <h2 className="section-title font-weight-bold mb-3">Skills</h2>
            <span className='mb-5 projectDesc'>
            I have tried many different technologies ,I'm in love with refreshing and always seekning for new changes , i'm always looking for better and better. Below is a quick overview of my main technical skill sets and technologies I use. Want to find out more about my experience? Check out my resume and project portfolio.
            </span>
            <div className='skillCats row'>
                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <VscCode className='skillIcon'/>
                    <p className='m-3'>Programming Languages</p>
                    </div>
                    <div>
                    <span className='skillDetail'>C ,C++ ,C# ,Java ,Python ,Go</span>
                    </div>
                </div>
                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <AiFillDatabase className='skillIcon'/>
                    <p className='m-3'>Database</p>
                    </div>
                    <div>
                    <span className='skillDetail'>SQL ,PL/SQL ,TSQL ,NO SQL ,Oracle ,SQL Server ,Mysql ,Mongodb</span>
                    </div>
                </div>

                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <VscGlobe className='skillIcon'/>
                    <p className='m-3'>Web Appliaction</p>
                    </div>
                    <div>
                    <span className='skillDetail'><b>BackEnd:</b> Asp.net (Core, MVC) , Node Js(express) ,Java Spring(MVC , Boot) ,Laravel ,Django</span><br></br>
                    <span className='skillDetail'><b>FrontEnd:</b> Html, Css ,Scss ,Javascript ,ES ,React ,Angular ,Vue Js</span>
                    </div>
                </div>
                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <MdPhoneAndroid className='skillIcon'/>
                    <p className='m-3'>Mobile Application</p>
                    </div>
                    <div>
                    <span className='skillDetail'><b>Native:</b> Java ,Kotilin ,Swift ,Objective C</span><br></br>
                    <span className='skillDetail'><b>Cross-Platform:</b> Flutter ,React Native</span>

                    </div>
                </div>

                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <AiOutlineCloud className='skillIcon'/>
                    <p className='m-3'>Cloud Technology</p>
                    </div>
                    <div>
                    <span className='skillDetail'>GCP (firebase), AWS (EC2 , Lambda , Beanstalk , RDS , SQS , SNS , CloudWatch .. etc)</span>
                    </div>
                </div>
                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <SiOracle className='skillIcon'/>
                    <p className='m-3'>ERP System</p>
                    </div>
                    <div>
                    <span className='skillDetail'>Oracle EBS (System administrator , EBS Developer , Techno-functional ) - O2C , P2P , OPM , HRMS ..etc </span>
                    </div>
                </div>
                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <AiFillGithub className='skillIcon'/>
                    <p className='m-3'>Version Control</p>
                    </div>
                    <div>
                    <span className='skillDetail'>GIT (Github,Gitlab)</span>
                    </div>
                </div>

                <div className='col col-12 col-sm-12 col-lg-6 col-md-12 skillItem'>
                    <div className='skillTitle'>
                    <SiDocker className='skillIcon'/>
                    <p className='m-3'>DevOps</p>
                    </div>
                    <div>
                    <span className='skillDetail'>Docker, Terraform (Basics)</span>
                    </div>
                </div>
            </div>

            </div>
            <div id='portfolio' className='section'>
            <h2 className="section-title font-weight-bold mb-3">Featured Projects</h2>
            <div className='mb-3 projectDesc'>
                Here is a list of some of my projects, i can not share and list all my projects here as they are created for an organization or a company , <b>if you want to see more Please contact me.</b>
                <div><b>I'm mentioning only some projects i have done as freelancer , thoese projects are not beloning to any company or organization that i have worked for as an employee.</b>
                </div>
            </div>
            <div className='sectionCat'>
            <div className='projectItem'>
                    <div className='projectTitle'>
                    <p>ZB POS & ZPharma</p>
                    </div>
                    <div className='row'>
                        <div className='col col-12 col-lg-6 col-sm-12'>
                    <span className='projectdetail'>ZB Point of Sale features a user-friendly, intuitive interface that any restaurant, shop, or retail company can utilize with the greatest of ease.This Solution contins Inventory , Purchaing , Payment Modules.</span>
                    <div className='mt-3'> <span className='projectdetail'><b>Used Technology :</b> Laravel(PHP) , VueJs and Live Wire , MySql</span></div>
                    </div>
                    <div style={{ "display":'flex' }} className='col col-12 col-lg-6 col-sm-12'>
                    <img alt='portfolio' height={200} src={process.env.PUBLIC_URL+"/Photo/ZBPOS.PNG"}></img>
                    </div>
                    </div>
                </div>
                <div className='projectItem'>
                    <div className='projectTitle'>
                    <p>Fast Post Kurdistan</p>
                    </div>
                    <div className='row'>
                        <div className='col col-12 col-lg-6 col-sm-12'>
                    <span className='projectdetail'>Mobile and Web Application , Used by Taxi Driver and shop owners, Fastpost company uses the appication to manage thier delivered and track thier orders , <a style={{ "textDecoration":"none" }} href='https://play.google.com/store/apps/details?id=com.zh.fastpost'>Playstore</a></span>
                    <div className='mt-3'> <span className='projectdetail'><b>Used Technology :</b> NodeJs(Express) , VueJs , Flutter (IOS , Android) , MongoDB</span></div>
                    </div>
                    <div style={{ "display":'flex' }} className='col col-12 col-lg-6 col-sm-12'>
                    <img alt='portfolio' height={200} src={process.env.PUBLIC_URL+"/Photo/fastpost1.PNG"}></img>
                    <img alt='portfolio' height={200} src={process.env.PUBLIC_URL+"/Photo/fastpost2.PNG"}></img>
                    </div>
                    </div>
                </div>

                <div className='projectItem'>
                    <div className='projectTitle'>
                    <p>Websites</p>
                    </div>
                    <div className='row'>
                        <div className='col col-12 col-lg-6 col-sm-12'>
                    <span className='projectdetail'>Developing & Designing websites for personal use , company websites based on customer's requirements ... Etc</span>
                    <div className='mt-3'> <span className='projectdetail'><b>Used Technology :</b> Different technologies ( laravel , VueJs, React , angular .. as per customer and technical requirements)</span></div>
                    </div>
                    <div style={{ "display":'flex','overflow':'hidden' }} className='col col-12 col-lg-6 col-sm-12'>
                    <img alt='portfolio' style={{ "objectFit":"cover" }} width={200} height={200} src={process.env.PUBLIC_URL+"/Photo/shyaw.PNG"}></img>
                    <img alt='portfolio' style={{ "objectFit":"cover" }} width={200} height={200} src={process.env.PUBLIC_URL+"/Photo/select.PNG"}></img>

                    </div>
                    </div>
                </div>

                <div className='projectItem'>
                    <div className='projectTitle'>
                    <p>Desktop Applications</p>
                    </div>
                    <div className='row'>
                        <div className='col col-12 col-lg-12 col-sm-12'>
                    <span className='projectdetail'>Developing Many Desktop appliaction and Background servicess running and processing tasks , datas and some applications for connecting to machines and reading serial and sensor datas , Ex: Bulk SMS Sending ,Notification Management, File compressor , Data Encrypter , WeightBridge Software .. Etc</span>
                    <div className='mt-3'> <span className='projectdetail'><b>Used Technology :</b> C++ , C# , Java , Oracle , MySql , MS Sql</span></div>
                    </div>
                    </div>
                </div>

                <div className='projectItem'>
                    <div className='projectTitle'>
                    <p>Embeded System Softwares</p>
                    </div>
                    <div className='row'>
                        <div className='col col-12 col-lg-12 col-sm-12'>
                    <span className='projectdetail'>Developing Embbeded system softwares for collecting data from different sensors and analyzing them for giving proper outpot , Examples : Smart House , Smart Remote Control System(GSM) , Weather  Station ..etc</span>
                    <div className='mt-3'> <span className='projectdetail'><b>Used Technology :</b>ESP 32 ,Arduino,Rasbery Pi , C++</span></div>
                    </div>
                    </div>
                </div>

            </div>
            </div>

            <div id='contact' className='section'>
            <h2 className="section-title font-weight-bold mb-3">Contact Me</h2>
            <p>Email : zhear997@gmail.com</p>
            <p>Whatsapp : +964 770 187 2487</p>
            <p>Phone : +964 772 999 1249 , +964 770 187 2487</p>
            <p>Github : zhiar97</p>
            <hr className='bottomborder' />
            <Footer/>

            </div>
        </div>
    }
}

export default MainContent;
